import { render, staticRenderFns } from "./ItemDescription.vue?vue&type=template&id=731036e6&"
import script from "./ItemDescription.vue?vue&type=script&lang=js&"
export * from "./ItemDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports